module.exports = __webpack_public_path__ + "static/img/music1_jkfa_icon.png";